import React, {useEffect, useState} from 'react'
import { Switch, Route, withRouter } from 'react-router-dom'
import {CircularProgress} from '@material-ui/core';

import Campaigns from '../Campaigns'
import CampaignDetails from '../Campaigns/CampaignDetails'
import CustomerList from '../CustomerList';
import CustomerListCreate from '../CustomerList/Create';
import AccountSettings from '../AccountSettings'
import Overview from '../Overview'
import ContentDiv, {FullPageDiv} from '../../../Components/Universal/ContentDiv';
import {DashboardContext, DashboardCtxDefault} from './context';

import {CreateCampaign} from '../Campaigns';
import useAxios from "axios-hooks";
import {getAdvertiser} from "../../../Api";
import {removeAuthToken} from "../../../Helpers";
import Footer from '../Auth/Footer';

const Dashboard = ({history}) => {
  const [advertiser, setAdvertiser] = useState(DashboardCtxDefault.advertiser);
  const [{error, loading, response}] = useAxios(getAdvertiser(), { manual: false });
  useEffect(() => {
    if (!loading && response && response.data) {
      if (response.data.error) {
        removeAuthToken();
        history.push('/auth/signin');
        return;
      }

      setAdvertiser(response.data.advertiser);
    } else if (error) {
      removeAuthToken();
      history.push('/auth/signin');
    }
  }, [response, advertiser, history, loading, error]);

  const nextPath = (path) => {
    history.push(path)
  };

  if (loading || !advertiser) {
    return (
      <FullPageDiv>
        <CircularProgress size={50} />
      </FullPageDiv>
    )
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: '100vh' }}>
      <ContentDiv>
        <DashboardContext.Provider value={{...DashboardCtxDefault, advertiser, setAdvertiser}}>
          <Switch>
            <Route
              exact path='/'
              component={Overview}
            />
            <Route
              path='/advertiser/campaigns/create'
              component={CreateCampaign}
            />
            <Route
              path='/advertiser/campaigns/:campaignId'
              component={CampaignDetails}
            />
            <Route
              path='/advertiser/campaigns'
              component={Campaigns}
            />
            <Route
              path='/advertiser/customerlists/create'
              component={CustomerListCreate}
            />
            <Route
              path='/advertiser/customerlists'
              component={CustomerList}
            />
            <Route
              path='/advertiser/accountsettings'
              component={AccountSettings}
            />
          </Switch>
        </DashboardContext.Provider>
      </ContentDiv>
      <Footer secondary />
    </div>
  )
};

export default withRouter(Dashboard);
